var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnique(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43593 13.2518V6.72124C8.43611 6.60435 8.48307 6.4923 8.56651 6.40965C8.64996 6.327 8.76308 6.28048 8.88109 6.2803H17.3608V4.99752C17.3608 4.86557 17.3079 4.73902 17.2137 4.64572C17.1195 4.55242 16.9917 4.5 16.8585 4.5H2.00229C1.93636 4.49991 1.87106 4.51269 1.81012 4.53762C1.74919 4.56255 1.69381 4.59913 1.64716 4.64527C1.60051 4.69142 1.5635 4.74622 1.53825 4.80654C1.513 4.86687 1.5 4.93153 1.5 4.99683V12.3623C1.50037 14.4454 2.33611 16.443 3.8234 17.9158C5.31068 19.3886 7.32769 20.2158 9.43075 20.2156C10.5008 20.2169 11.56 20.003 12.5441 19.587C11.3188 19.0316 10.2802 18.1393 9.55195 17.0162C8.82368 15.8931 8.43632 14.5865 8.43593 13.2518Z",
    fill: "url(#paint0_linear_943_16345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 6.72121C22.4997 6.60432 22.4527 6.49227 22.3693 6.40962C22.2858 6.32697 22.1727 6.28046 22.0547 6.28027H17.3606V12.3623C17.3607 13.9017 16.9042 15.4072 16.0479 16.6918C15.1916 17.9765 13.9732 18.9837 12.5439 19.5884C13.4621 20.0043 14.4602 20.2188 15.4699 20.217C17.3346 20.2165 19.1227 19.4824 20.441 18.1762C21.7593 16.87 22.4999 15.0987 22.4999 13.2517V6.72121Z",
    fill: "url(#paint1_linear_943_16345)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_16345",
    x1: 0.967754,
    y1: 19.4545,
    x2: 12.2368,
    y2: 5.69782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#210D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#361463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#581F85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_16345",
    x1: 15.9764,
    y1: 19.5849,
    x2: 22.8678,
    y2: 3.42127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC300"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnique);
export default __webpack_public_path__ + "static/media/unique.06a4857229a48ed368f62e117cc32c99.svg";
export { ForwardRef as ReactComponent };